import type { DashboardSummaryPeriod } from "../types/dashboard.types";

export function formatDashboardCount(n: number): string {
  return new Intl.NumberFormat("en-IN", { maximumFractionDigits: 0 }).format(
    n,
  );
}

export function formatDashboardCurrency(
  amount: number,
  currency: string,
): string {
  const code = currency?.trim().toUpperCase() || "INR";
  try {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: code,
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(amount);
  } catch {
    return `${formatDashboardCount(amount)} ${code}`;
  }
}

const MONTH_NAMES = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
] as const;

export function formatDashboardPeriodLabel(period: DashboardSummaryPeriod): string {
  const m = MONTH_NAMES[period.month - 1];
  if (!m) return `${period.year}`;
  return `${m} ${period.year}`;
}
